import {
  IObjeto,
  IDadosGraficoSeriesMultiplas,
  IDadosGraficoRadar,
  ISecao,
} from './apiFake'; // esses são os tipos do front que os gráficos reconhecem - dar nomes melhores e armazenar em local mais devido
// são até usados na tela

import api from '../services/api';

export enum eFiltroPagina {
  GERAL = 'GERAL',
  DIARIO = 'DIARIO',
  // SEMANAL = 'SEMANAL',
  MENSAL = 'MENSAL',
  ANUAL = 'ANUAL',
  PERIODO = 'PERIODO',
}

export interface Pagina {
  id: string;
  nome: string;
  filtro: eFiltroPagina;
  empresa_id?: string;
  secoes: Secao[];
}

export interface Secao {
  id: string;
  // pagina_id: string;
  nome?: string;
  qtdeDados?: number;
  objetos: Objeto[];
}

export interface Objeto {
  id: string;
  nome: string;
  tipo: string;
  percentual_tela: number;
  series?: ObjetoSerie[] | null;
  multiplas_series?: ObjetoMultiSerie[] | null;
  cartao?: ObjetoCartao;

  [key: string]: any; // Adiciona suporte para chaves dinâmicas
}

export interface ObjetoCartao {
  data?: Date;
  valor: string;
  percentual?: number;
  descricao?: string;
}

export interface ObjetoSerie {
  data: Date;
  nome: string;
  valor: number;
}

export interface ObjetoMultiSerie {
  nome: string;
  series: ObjetoMultiSerieDado[];
}

export interface ObjetoMultiSerieDado {
  data?: Date;
  nome: string;
  valor: number;
}

export function BuscarSomentePaginas(): Pagina[] {
  const initialPaginas: Pagina[] = [
    {
      id: '1',
      nome: 'PDV - DIÁRIO',
      filtro: eFiltroPagina.DIARIO,
      secoes: [],
    },
    {
      id: '2',
      nome: 'PDV - MENSAL',
      filtro: eFiltroPagina.MENSAL,
      secoes: [],
    },
    {
      id: '3',
      nome: 'PDV - ANUAL',
      filtro: eFiltroPagina.ANUAL,
      secoes: [],
    },
    {
      id: '4',
      nome: 'PDV - PERÍODO',
      filtro: eFiltroPagina.PERIODO,
      secoes: [],
    },
    {
      id: '5',
      nome: 'TODOS GRÁFICOS',
      filtro: eFiltroPagina.GERAL,
      secoes: [],
    },
  ];

  return initialPaginas;
}

export function BuscarPagina(idPagina: string): Pagina | undefined {
  const paginas = DadosFake();
  const paginaEncontrada = paginas.find(pagina => pagina.id === idPagina);
  return paginaEncontrada;
}

function DadosFake(): Pagina[] {
  const initialPaginas: Pagina[] = [
    {
      id: '1',
      nome: 'PDV - DIÁRIO',
      filtro: eFiltroPagina.DIARIO,
      secoes: [
        {
          id: '210',
          qtdeDados: 3,
          objetos: [
            {
              id: '1',
              percentual_tela: 50,
              nome: 'CAIXAS',
              tipo: 'BAR',
              multiplas_series: [
                {
                  nome: 'Caixas',
                  series: [
                    {
                      nome: 'Caixa1',
                      valor: 400,
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        new Date().getDate(),
                      ),
                    },
                    {
                      nome: 'Caixa2',
                      valor: 240,
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        new Date().getDate(),
                      ),
                    },
                    {
                      nome: 'Caixa3',
                      valor: 240,
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        new Date().getDate(),
                      ),
                    },
                  ],
                },
              ],
            },
            {
              id: '2',
              percentual_tela: 25,
              nome: 'CAIXAS',
              tipo: 'ROSCA',
              series: [
                {
                  nome: 'Caixa 1',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    new Date().getDate(),
                  ),
                  valor: 400,
                },
                {
                  nome: 'Caixa 2',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    new Date().getDate(),
                  ),
                  valor: 240,
                },
                {
                  nome: 'Caixa 3',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    new Date().getDate(),
                  ),
                  valor: 240,
                },
              ],
            },
            {
              id: '3',
              percentual_tela: 25,
              nome: 'Total dos Caixas',
              tipo: 'CARD',
              cartao: {
                data: new Date(
                  new Date().getFullYear(),
                  new Date().getMonth(),
                  new Date().getDate(),
                ),
                valor: 'R$ 880,00',
                percentual: 5,
                descricao: 'em relação a ontem',
              },
            },
          ],
        },
      ],
    },
    {
      id: '2',
      nome: 'PDV - MENSAL',
      filtro: eFiltroPagina.MENSAL,
      secoes: [
        {
          id: '1',
          qtdeDados: 2,
          objetos: [
            {
              id: '2',
              percentual_tela: 50,
              nome: 'DESPESAS MENSAIS POR CATEGORIA',
              tipo: 'ROSCA',
              series: [
                {
                  nome: 'Pessoal',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 8000,
                },
                {
                  nome: 'Material',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 6000,
                },
                {
                  nome: 'Frota',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 4000,
                },
                {
                  nome: 'Aluguel',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 5000,
                },
                {
                  nome: 'Outros',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 2000,
                },
              ],
            },
            {
              id: '3',
              percentual_tela: 50,
              nome: 'RECEITAS MENSAIS POR CATEGORIA',
              tipo: 'PIZZA',
              series: [
                {
                  nome: 'Vendas',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 12000,
                },
                {
                  nome: 'Aluguel',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 2000,
                },
                {
                  nome: 'Comissão',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 4000,
                },
              ],
            },
          ],
        },
        {
          id: '3',
          qtdeDados: 3,
          objetos: [
            {
              id: '4',
              percentual_tela: 33.33,
              nome: 'TOP 10 CLIENTES MENSAIS',
              tipo: 'PIZZA',
              series: [
                {
                  nome: 'Cliente A',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 15000,
                },
                {
                  nome: 'Cliente B',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 12000,
                },
                {
                  nome: 'Cliente C',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 10000,
                },
                {
                  nome: 'Cliente D',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 9000,
                },
                {
                  nome: 'Cliente E',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 8500,
                },
                {
                  nome: 'Cliente F',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 8000,
                },
                {
                  nome: 'Cliente G',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 7500,
                },
                {
                  nome: 'Cliente H',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 7000,
                },
                {
                  nome: 'Cliente I',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 6500,
                },
                {
                  nome: 'Cliente J',
                  data: new Date(
                    new Date().getFullYear(),
                    new Date().getMonth(),
                    1,
                  ),
                  valor: 6000,
                },
              ],
            },
            {
              id: '3',
              nome: 'TOP 10 CLIENTES MENSAIS',
              tipo: 'BAR',
              percentual_tela: 33.34,
              multiplas_series: [
                {
                  nome: 'Clientes',
                  series: [
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Cliente A',
                      valor: 15000,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Cliente B',
                      valor: 12000,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Cliente C',
                      valor: 10000,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Cliente D',
                      valor: 9000,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Cliente E',
                      valor: 8500,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Cliente F',
                      valor: 8000,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Cliente G',
                      valor: 7500,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Cliente H',
                      valor: 7000,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Cliente I',
                      valor: 6500,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Cliente J',
                      valor: 6000,
                    },
                  ],
                },
              ],
            },
            {
              id: '6',
              nome: 'META DE RECEITAS',
              tipo: 'RADAR',
              percentual_tela: 33.33,
              multiplas_series: [
                {
                  nome: 'Vendas',
                  series: [
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Planejado',
                      valor: 14000,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Realizado',
                      valor: 12000,
                    },
                  ],
                },
                {
                  nome: 'Comissão',
                  series: [
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Planejado',
                      valor: 3000,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Realizado',
                      valor: 4000,
                    },
                  ],
                },
                {
                  nome: 'Aluguel',
                  series: [
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Planejado',
                      valor: 8000,
                    },
                    {
                      data: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                      ),
                      nome: 'Realizado',
                      valor: 4000,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: '3',
      nome: 'PDV - ANUAL',
      filtro: eFiltroPagina.ANUAL,
      secoes: [
        {
          //2024
          id: '120',
          qtdeDados: 1,
          objetos: [
            {
              id: '99',
              percentual_tela: 100,
              nome: 'RECEITAS ANUAIS',
              tipo: 'AREA',
              series: [
                { nome: 'Jan', data: new Date(2024, 0, 1), valor: 700 },
                { nome: 'Fev', data: new Date(2024, 0, 1), valor: 500 },
                { nome: 'Mar', data: new Date(2024, 0, 1), valor: 550 },
                { nome: 'Abr', data: new Date(2024, 0, 1), valor: 250 },
                { nome: 'Mai', data: new Date(2024, 0, 1), valor: 350 },
                { nome: 'Jun', data: new Date(2024, 0, 1), valor: 400 },
                { nome: 'Jul', data: new Date(2024, 0, 1), valor: 650 },
                { nome: 'Ago', data: new Date(2024, 0, 1), valor: 550 },
                { nome: 'Set', data: new Date(2024, 0, 1), valor: 500 },
                { nome: 'Out', data: new Date(2024, 0, 1), valor: 700 },
                { nome: 'Nov', data: new Date(2024, 0, 1), valor: 750 },
                { nome: 'Dez', data: new Date(2024, 0, 1), valor: 450 },
              ],
            },
          ],
        },
        {
          id: '130',
          qtdeDados: 1,
          objetos: [
            {
              id: '114',
              percentual_tela: 100,
              nome: 'RECEITAS ANUAIS',
              tipo: 'AREA',
              series: [
                {
                  nome: 'Jan',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 400,
                },
                {
                  nome: 'Fev',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 300,
                },
                {
                  nome: 'Mar',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 500,
                },
                {
                  nome: 'Abr',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 200,
                },
                {
                  nome: 'Mai',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 600,
                },
                {
                  nome: 'Jun',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 400,
                },
                {
                  nome: 'Jul',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 700,
                },
                {
                  nome: 'Ago',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 550,
                },
                {
                  nome: 'Set',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 600,
                },
                {
                  nome: 'Out',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 750,
                },
                {
                  nome: 'Nov',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 600,
                },
                {
                  nome: 'Dez',
                  data: new Date(new Date().getFullYear(), 0, 1),
                  valor: 700,
                },
              ],
            },
          ],
        },
        {
          id: '150',
          qtdeDados: 1,
          objetos: [
            {
              id: '8',
              nome: 'RECEITAS ANUAIS DETALHADAS',
              tipo: 'STACKED-AREA',
              percentual_tela: 100,
              multiplas_series: [
                {
                  nome: 'Jan',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 300,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 50,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 50,
                    },
                  ],
                },
                {
                  nome: 'Fev',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 200,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 50,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 50,
                    },
                  ],
                },
                {
                  nome: 'Mar',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 250,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 150,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 100,
                    },
                  ],
                },
                {
                  nome: 'Abr',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 50,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 100,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 50,
                    },
                  ],
                },
                {
                  nome: 'Mai',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 250,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 300,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 50,
                    },
                  ],
                },
                {
                  nome: 'Jun',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 400,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 0,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 0,
                    },
                  ],
                },
                {
                  nome: 'Jul',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 400,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 200,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 100,
                    },
                  ],
                },
                {
                  nome: 'Ago',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 250,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 200,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 100,
                    },
                  ],
                },
                {
                  nome: 'Set',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 200,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 200,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 200,
                    },
                  ],
                },
                {
                  nome: 'Out',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 450,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 150,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 150,
                    },
                  ],
                },
                {
                  nome: 'Nov',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 500,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 60,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 40,
                    },
                  ],
                },
                {
                  nome: 'Dez',
                  series: [
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Vendas',
                      valor: 550,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Comissão',
                      valor: 50,
                    },
                    {
                      data: new Date(new Date().getFullYear(), 0, 1),
                      nome: 'Aluguel',
                      valor: 100,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: '4',
      nome: 'PDV - PERÍODO',
      filtro: eFiltroPagina.PERIODO,
      secoes: [
        {
          id: '180',
          qtdeDados: 1,
          objetos: [
            {
              id: '8',
              nome: 'STACKED-BAR',
              tipo: 'STACKED-BAR',
              percentual_tela: 100,
              multiplas_series: [
                {
                  nome: new Date(
                    new Date().setDate(new Date().getDate() - 5),
                  ).toLocaleDateString('pt-BR'),
                  series: [
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 5),
                      ),
                      nome: 'GroupA',
                      valor: 400,
                    },
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 5),
                      ),
                      nome: 'GroupB',
                      valor: 240,
                    },
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 5),
                      ),
                      nome: 'GroupC',
                      valor: 240,
                    },
                  ],
                },
                {
                  nome: new Date(
                    new Date().setDate(new Date().getDate() - 4),
                  ).toLocaleDateString('pt-BR'),
                  series: [
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 4),
                      ),
                      nome: 'GroupA',
                      valor: 300,
                    },
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 4),
                      ),
                      nome: 'GroupB',
                      valor: 139,
                    },
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 4),
                      ),
                      nome: 'GroupC',
                      valor: 221,
                    },
                  ],
                },
                {
                  nome: new Date(
                    new Date().setDate(new Date().getDate() - 3),
                  ).toLocaleDateString('pt-BR'),
                  series: [
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 3),
                      ),
                      nome: 'GroupA',
                      valor: 200,
                    },
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 3),
                      ),
                      nome: 'GroupB',
                      valor: 980,
                    },
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 3),
                      ),
                      nome: 'GroupC',
                      valor: 229,
                    },
                  ],
                },
                {
                  nome: new Date(
                    new Date().setDate(new Date().getDate() - 2),
                  ).toLocaleDateString('pt-BR'),
                  series: [
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 2),
                      ),
                      nome: 'GroupA',
                      valor: 278,
                    },
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 2),
                      ),
                      nome: 'GroupB',
                      valor: 390,
                    },
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 2),
                      ),
                      nome: 'GroupC',
                      valor: 200,
                    },
                  ],
                },
                {
                  nome: new Date(
                    new Date().setDate(new Date().getDate() - 1),
                  ).toLocaleDateString('pt-BR'),
                  series: [
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 1),
                      ),
                      nome: 'GroupA',
                      valor: 189,
                    },
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 1),
                      ),
                      nome: 'GroupB',
                      valor: 480,
                    },
                    {
                      data: new Date(
                        new Date().setDate(new Date().getDate() - 1),
                      ),
                      nome: 'GroupC',
                      valor: 218,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: '5',
      nome: 'TODOS GRÁFICOS',
      filtro: eFiltroPagina.GERAL,
      secoes: [
        {
          id: '1',
          qtdeDados: 4,
          objetos: [
            {
              id: '9',
              percentual_tela: 30,
              nome: 'PIZZA',
              tipo: 'PIZZA',
              series: [
                { nome: 'Group A', data: new Date(2024, 11, 1), valor: 400 },
                { nome: 'Group B', data: new Date(2024, 11, 1), valor: 300 },
                { nome: 'Group C', data: new Date(2024, 11, 1), valor: 300 },
                { nome: 'Group D', data: new Date(2024, 11, 1), valor: 200 },
              ],
            },
            {
              id: '10',
              percentual_tela: 30,
              nome: 'ROSCA',
              tipo: 'ROSCA',
              series: [
                { nome: 'Group A', data: new Date(2024, 11, 1), valor: 500 },
                { nome: 'Group B', data: new Date(2024, 11, 1), valor: 250 },
                { nome: 'Group C', data: new Date(2024, 11, 1), valor: 200 },
                { nome: 'Group D', data: new Date(2024, 11, 1), valor: 100 },
              ],
            },
            {
              id: '17',
              percentual_tela: 21,
              nome: 'Lucro Anual (CARD)',
              tipo: 'CARD',
              cartao: {
                valor: 'R$ 8.500,00',
                percentual: 5,
                descricao: 'teste de descrição',
              },
            },
            {
              id: '18',
              percentual_tela: 14,
              nome: 'Nº Clientes (CARD)',
              tipo: 'CARD',
              cartao: {
                valor: '1.450',
                // percentual: 5,
                descricao: 'mensalistas',
              },
            },
          ],
        },
        {
          id: '170',
          qtdeDados: 1,
          objetos: [
            {
              id: '11',
              percentual_tela: 100,
              nome: 'AREA',
              tipo: 'AREA',
              series: [
                { nome: 'Jan', data: new Date(2024, 11, 1), valor: 400 },
                { nome: 'Feb', data: new Date(2024, 11, 1), valor: 300 },
                { nome: 'Mar', data: new Date(2024, 11, 1), valor: 500 },
                { nome: 'Apr', data: new Date(2024, 11, 1), valor: 200 },
                { nome: 'May', data: new Date(2024, 11, 1), valor: 600 },
              ],
            },
          ],
        },
        {
          id: '180',
          qtdeDados: 1,
          objetos: [
            {
              id: '8',
              nome: 'STACKED-AREA',
              tipo: 'STACKED-AREA',
              percentual_tela: 100,
              multiplas_series: [
                {
                  nome: 'Jan',
                  series: [
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupA',
                      valor: 400,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupB',
                      valor: 240,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupC',
                      valor: 240,
                    },
                  ],
                },
                {
                  nome: 'Feb',
                  series: [
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupA',
                      valor: 300,
                    },
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupB',
                      valor: 139,
                    },
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupC',
                      valor: 221,
                    },
                  ],
                },
                {
                  nome: 'Mar',
                  series: [
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupA',
                      valor: 200,
                    },
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupB',
                      valor: 980,
                    },
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupC',
                      valor: 229,
                    },
                  ],
                },
                {
                  nome: 'Apr',
                  series: [
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupA',
                      valor: 278,
                    },
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupB',
                      valor: 390,
                    },
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupC',
                      valor: 200,
                    },
                  ],
                },
                {
                  nome: 'May',
                  series: [
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupA',
                      valor: 189,
                    },
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupB',
                      valor: 480,
                    },
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupC',
                      valor: 218,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: '190',
          qtdeDados: 2,
          objetos: [
            {
              id: '13',
              nome: 'PERCENT-AREA',
              tipo: 'PERCENT-AREA',
              percentual_tela: 50,
              multiplas_series: [
                {
                  nome: 'Jan',
                  series: [
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupA',
                      valor: 0.4,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupB',
                      valor: 0.3,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupC',
                      valor: 0.3,
                    },
                  ],
                },
                {
                  nome: 'Feb',
                  series: [
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupA',
                      valor: 0.3,
                    },
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupB',
                      valor: 0.4,
                    },
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupC',
                      valor: 0.3,
                    },
                  ],
                },
                {
                  nome: 'Mar',
                  series: [
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupA',
                      valor: 0.2,
                    },
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupB',
                      valor: 0.3,
                    },
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupC',
                      valor: 0.5,
                    },
                  ],
                },
                {
                  nome: 'Apr',
                  series: [
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupA',
                      valor: 0.3,
                    },
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupB',
                      valor: 0.2,
                    },
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupC',
                      valor: 0.5,
                    },
                  ],
                },
                {
                  nome: 'May',
                  series: [
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupA',
                      valor: 0.18,
                    },
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupB',
                      valor: 0.32,
                    },
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupC',
                      valor: 0.5,
                    },
                  ],
                },
              ],
            },
            {
              id: '14',
              nome: 'BAR',
              tipo: 'BAR',
              percentual_tela: 50,
              multiplas_series: [
                {
                  nome: 'Jan',
                  series: [
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupA',
                      valor: 400,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupB',
                      valor: 240,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupC',
                      valor: 240,
                    },
                  ],
                },
                {
                  nome: 'Feb',
                  series: [
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupA',
                      valor: 300,
                    },
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupB',
                      valor: 139,
                    },
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupC',
                      valor: 221,
                    },
                  ],
                },
                {
                  nome: 'Mar',
                  series: [
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupA',
                      valor: 200,
                    },
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupB',
                      valor: 980,
                    },
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupC',
                      valor: 229,
                    },
                  ],
                },
                {
                  nome: 'Apr',
                  series: [
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupA',
                      valor: 278,
                    },
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupB',
                      valor: 390,
                    },
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupC',
                      valor: 200,
                    },
                  ],
                },
                {
                  nome: 'May',
                  series: [
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupA',
                      valor: 189,
                    },
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupB',
                      valor: 480,
                    },
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupC',
                      valor: 218,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: '200',
          qtdeDados: 2,
          objetos: [
            {
              id: '15',
              nome: 'STACKED-BAR',
              tipo: 'STACKED-BAR',
              percentual_tela: 70,
              multiplas_series: [
                {
                  nome: 'Jan',
                  series: [
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupA',
                      valor: 400,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupB',
                      valor: 240,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'GroupC',
                      valor: 240,
                    },
                  ],
                },
                {
                  nome: 'Feb',
                  series: [
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupA',
                      valor: 300,
                    },
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupB',
                      valor: 139,
                    },
                    {
                      data: new Date(2025, 1, 1),
                      nome: 'GroupC',
                      valor: 221,
                    },
                  ],
                },
                {
                  nome: 'Mar',
                  series: [
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupA',
                      valor: 200,
                    },
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupB',
                      valor: 980,
                    },
                    {
                      data: new Date(2025, 2, 1),
                      nome: 'GroupC',
                      valor: 229,
                    },
                  ],
                },
                {
                  nome: 'Apr',
                  series: [
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupA',
                      valor: 278,
                    },
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupB',
                      valor: 390,
                    },
                    {
                      data: new Date(2025, 3, 1),
                      nome: 'GroupC',
                      valor: 200,
                    },
                  ],
                },
                {
                  nome: 'May',
                  series: [
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupA',
                      valor: 189,
                    },
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupB',
                      valor: 480,
                    },
                    {
                      data: new Date(2025, 4, 1),
                      nome: 'GroupC',
                      valor: 218,
                    },
                  ],
                },
              ],
            },
            {
              id: '16',
              nome: 'RADAR',
              tipo: 'RADAR',
              percentual_tela: 30,
              multiplas_series: [
                {
                  nome: 'Math',
                  series: [
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'A',
                      valor: 120,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'B',
                      valor: 100,
                    },
                  ],
                },
                {
                  nome: 'Science',
                  series: [
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'A',
                      valor: 125,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'B',
                      valor: 100,
                    },
                  ],
                },
                {
                  nome: 'English',
                  series: [
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'A',
                      valor: 86,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'B',
                      valor: 100,
                    },
                  ],
                },
                {
                  nome: 'History',
                  series: [
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'A',
                      valor: 99,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'B',
                      valor: 100,
                    },
                  ],
                },
                {
                  nome: 'Art',
                  series: [
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'A',
                      valor: 105,
                    },
                    {
                      data: new Date(2025, 0, 1),
                      nome: 'B',
                      valor: 90,
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  return initialPaginas;
}

// Filtra gráficos preenchidos no novo padrão de dados
export function filtrarGraficosPreenchidos(secao: Secao): Secao | null {
  const novaSecao: Secao = { ...secao, objetos: [...secao.objetos] };

  let temDados = false;

  novaSecao.objetos = novaSecao.objetos.map(dado => {
    const novoDado = { ...dado };

    Object.keys(novoDado).forEach(chave => {
      if (
        (chave === 'multiplas_series' || chave === 'series') &&
        Array.isArray(novoDado[chave])
      ) {
        const grafico = novoDado[chave];
        if (grafico && grafico.length > 0) {
          temDados = true;
        } else {
          novoDado[chave] = null; // Remove gráficos sem dados
        }
      }

      if (chave === 'cartao' && novoDado.cartao?.data) {
        temDados = true;
      }
    });

    return novoDado;
  });

  return temDados ? novaSecao : null;
}

// Filtra seções por período no novo padrão
export async function buscarSecoesPeriodo(
  idPagina: string,
  dataInicial: string,
  dataFinal: string,
  nomeSistema: string,
): Promise<Secao[]> {
  if (nomeSistema.toUpperCase() === 'EXEMPLO') {
    const [yearIni, monthIni, dayIni] = dataInicial.split('-').map(Number);
    const inicio = new Date(yearIni, monthIni - 1, dayIni);
    const [yearFim, monthFim, dayFim] = dataFinal.split('-').map(Number);
    const fim = new Date(yearFim, monthFim - 1, dayFim);

    return DadosFake()
      .filter(pagina => pagina.id === idPagina)
      .flatMap(pagina => pagina.secoes)
      .map(secao => ({
        ...secao,
        objetos: secao.objetos.map(dado => ({
          ...dado,
          ...Object.keys(dado)
            .filter(
              key =>
                key === 'multiplas_series' ||
                key === 'series' ||
                key === 'cartao',
            )
            .reduce((acc, key) => {
              const grafico = dado[key];
              if (Array.isArray(grafico)) {
                acc[key] = grafico.filter(item => {
                  if ('series' in item) {
                    return item.series?.some(
                      (serie: ObjetoMultiSerieDado) =>
                        serie.data && serie.data >= inicio && serie.data <= fim,
                    );
                  }
                  return item.data >= inicio && item.data <= fim; // Para gráficos simples como Pizza/Rosca
                });
              } else if (key === 'cartao' && grafico?.data) {
                acc[key] =
                  grafico.data >= inicio && grafico.data <= fim
                    ? grafico
                    : null;
              }
              return acc;
            }, {} as Record<string, any>),
        })),
      }))
      .map(filtrarGraficosPreenchidos)
      .filter(Boolean) as Secao[];
  } else {
    const retorno = await api.get<Secao[]>('painel/pagina-periodo', {
      params: {
        data_inicial: dataInicial,
        data_final: dataFinal,
        pagina_id: idPagina,
      },
    });

    const retornoTratado = retorno.data
      .map(filtrarGraficosPreenchidos)
      .filter(Boolean) as Secao[];

    return retornoTratado;
  }
}

// Filtra seções para um dia específico no novo padrão
export async function buscarSecoesDia(
  idPagina: string,
  dataInicial: string,
  nomeSistema: string,
): Promise<Secao[]> {
  if (nomeSistema.toUpperCase() === 'EXEMPLO') {
    const data = new Date(dataInicial);

    return DadosFake()
      .filter(pagina => pagina.id === idPagina)
      .flatMap(pagina => pagina.secoes)
      .map(secao => ({
        ...secao,
        objetos: secao.objetos.map(dado => ({
          ...dado,
          ...Object.keys(dado)
            .filter(
              key =>
                key === 'multiplas_series' ||
                key === 'series' ||
                key === 'cartao',
            )
            .reduce((acc, key) => {
              const grafico = dado[key];
              if (Array.isArray(grafico)) {
                acc[key] = grafico.filter(item => {
                  if ('series' in item) {
                    return item.series?.some(
                      (serie: ObjetoMultiSerieDado) =>
                        serie.data &&
                        serie.data.toISOString().split('T')[0] ===
                          data.toISOString().split('T')[0],
                    );
                  }
                  return (
                    item.data.toISOString().split('T')[0] ===
                    data.toISOString().split('T')[0]
                  );
                });
              } else if (key === 'cartao' && grafico?.data) {
                acc[key] =
                  grafico.data.toISOString().split('T')[0] ===
                  data.toISOString().split('T')[0]
                    ? grafico
                    : null;
              }
              return acc;
            }, {} as Record<string, any>),
        })),
      }))
      .map(filtrarGraficosPreenchidos)
      .filter(Boolean) as Secao[];
  } else {
    const retorno = await api.get<Secao[]>('painel/pagina-dia', {
      params: {
        dia: dataInicial,
        pagina_id: idPagina,
      },
    });

    const retornoTratado = retorno.data
      .map(filtrarGraficosPreenchidos)
      .filter(Boolean) as Secao[];

    return retornoTratado;
  }
}

// Filtra seções para um mês específico no novo padrão
export async function buscarSecoesMes(
  idPagina: string,
  dataInicial: string,
  nomeSistema: string,
): Promise<Secao[]> {
  const [ano, mes] = dataInicial.split('-').map(Number);

  if (nomeSistema.toUpperCase() === 'EXEMPLO') {
    return DadosFake()
      .filter(pagina => pagina.id === idPagina)
      .flatMap(pagina => pagina.secoes)
      .map(secao => ({
        ...secao,
        objetos: secao.objetos.map(dado => ({
          ...dado,
          ...Object.keys(dado)
            .filter(
              key =>
                key === 'multiplas_series' ||
                key === 'series' ||
                key === 'cartao',
            )
            .reduce((acc, key) => {
              const grafico = dado[key];
              // if (dado.nome === 'CUSTOS OPERACIONAIS MENSAIS') {
              //     console.log('dados');
              //     console.log(dado);
              // }
              if (Array.isArray(grafico)) {
                // if (dado.nome === 'CUSTOS OPERACIONAIS MENSAIS') {
                //     console.log('coluna');
                //     console.log(grafico);
                //     console.log(ano, mes - 1);
                // }
                acc[key] = grafico.filter(item => {
                  if ('series' in item) {
                    return item.series?.some(
                      (serie: ObjetoMultiSerieDado) =>
                        serie.data &&
                        serie.data.getFullYear() === ano &&
                        serie.data.getMonth() === mes - 1,
                    );
                  }
                  return (
                    item.data.getFullYear() === ano &&
                    item.data.getMonth() === mes - 1
                  );
                });
              } else if (key === 'cartao' && grafico?.data) {
                acc[key] =
                  grafico.data.getFullYear() === ano &&
                  grafico.data.getMonth() === mes - 1
                    ? grafico
                    : null;
              }
              return acc;
            }, {} as Record<string, any>),
        })),
      }))
      .map(filtrarGraficosPreenchidos)
      .filter(Boolean) as Secao[];
  } else {
    const dataFiltro = `${ano}-${mes.toString().padStart(2, '0')}`;
    const retorno = await api.get<Secao[]>('painel/pagina-mes', {
      params: {
        data_inicial: dataFiltro,
        pagina_id: idPagina,
      },
    });

    const retornoTratado = retorno.data
      .map(filtrarGraficosPreenchidos)
      .filter(Boolean) as Secao[];

    return retornoTratado;
  }
}

// Filtra seções para um ano específico no novo padrão
export async function buscarSecoesAno(
  idPagina: string,
  dataInicial: string,
  nomeSistema: string,
): Promise<Secao[]> {
  const ano = Number(dataInicial);

  if (nomeSistema.toUpperCase() === 'EXEMPLO') {
    return DadosFake()
      .filter(pagina => pagina.id === idPagina)
      .flatMap(pagina => pagina.secoes)
      .map(secao => ({
        ...secao,
        objetos: secao.objetos.map(dado => ({
          ...dado,
          ...Object.keys(dado)
            .filter(
              key =>
                key === 'multiplas_series' ||
                key === 'series' ||
                key === 'cartao',
            )
            .reduce((acc, key) => {
              const grafico = dado[key];
              if (Array.isArray(grafico)) {
                acc[key] = grafico.filter(item => {
                  if ('series' in item) {
                    return item.series?.some(
                      (serie: ObjetoMultiSerieDado) =>
                        serie.data && serie.data.getFullYear() === ano,
                    );
                  }
                  return item.data.getFullYear() === ano;
                });
              } else if (key === 'cartao' && grafico?.data) {
                acc[key] = grafico.data.getFullYear() === ano ? grafico : null;
              }
              return acc;
            }, {} as Record<string, any>),
        })),
      }))
      .map(filtrarGraficosPreenchidos)
      .filter(Boolean) as Secao[];
  } else {
    const retorno = await api.get<Secao[]>('painel/pagina-ano', {
      params: {
        ano: String(ano),
        pagina_id: idPagina,
      },
    });

    const retornoTratado = retorno.data
      .map(filtrarGraficosPreenchidos)
      .filter(Boolean) as Secao[];

    return retornoTratado;
  }
}

// Filtra seções gerais no novo padrão
export async function buscarSecoesGeral(
  idPagina: string,
  nomeSistema: string,
): Promise<Secao[]> {
  if (nomeSistema.toUpperCase() === 'EXEMPLO') {
    const dados = DadosFake()
      .filter(pagina => pagina.id === idPagina)
      .flatMap(pagina => pagina.secoes)
      .map(filtrarGraficosPreenchidos)
      .filter(Boolean) as Secao[];

    return dados;
  } else {
    const retorno = await api.get<Secao[]>('painel/pagina-geral', {
      params: {
        pagina_id: idPagina,
      },
    });

    const retornoTratado = retorno.data
      .map(filtrarGraficosPreenchidos)
      .filter(Boolean) as Secao[];

    return retornoTratado;
  }
}

export function converterDadosParaSecoes(secoes: Secao[]): ISecao[] {
  return secoes.map(secao => {
    const novaSecao: ISecao = {
      id: secao.id,
      qtdeDados: secao.qtdeDados,
      objetos: secao.objetos.map(objeto => {
        const novoObjeto: IObjeto = {
          id: objeto.id,
          nome: objeto.nome,
          tipo: objeto.tipo,
          percentual_tela: objeto.percentual_tela,
        };

        const tratarData = (data: any): Date => {
          return data instanceof Date ? data : new Date(data || 0);
        };

        // Conversão para STACKED-BAR
        if (objeto.tipo === 'STACKED-BAR' && objeto.multiplas_series) {
          novoObjeto.multiplas_series = objeto.multiplas_series.map(item => {
            const { nome, series } = item;
            const seriesOrdenadas = series
              .map(serie => ({
                ...serie,
                date: tratarData(serie.data),
              }))
              .sort((a, b) => a.date.getTime() - b.date.getTime());
            return new IDadosGraficoSeriesMultiplas(
              nome,
              seriesOrdenadas.reduce((acc, serie) => {
                acc[serie.nome] = serie.valor;
                return acc;
              }, {} as Record<string, number>),
            );
          });
        }

        // Conversão para RADAR
        if (objeto.tipo === 'RADAR' && objeto.multiplas_series) {
          novoObjeto.graficoRadar = objeto.multiplas_series.map(item => {
            const { nome, series } = item;
            return new IDadosGraficoRadar(
              nome,
              series.reduce((acc, serie) => {
                acc[serie.nome] = serie.valor;
                return acc;
              }, {} as Record<string, number>),
            );
          });
        }

        if (objeto.tipo === 'BAR' && objeto.multiplas_series) {
          novoObjeto.multiplas_series = objeto.multiplas_series.map(item => {
            const { nome, series } = item;
            const seriesOrdenadas = series
              .map(serie => ({
                ...serie,
                date: tratarData(serie.data),
              }))
              .sort((a, b) => a.date.getTime() - b.date.getTime());
            return new IDadosGraficoSeriesMultiplas(
              nome,
              seriesOrdenadas.reduce((acc, serie) => {
                acc[serie.nome] = serie.valor;
                return acc;
              }, {} as Record<string, number>),
            );
          });
        }

        if (objeto.tipo === 'STACKED-AREA' && objeto.multiplas_series) {
          novoObjeto.multiplas_series = objeto.multiplas_series.map(item => {
            const { nome, series } = item;
            const seriesOrdenadas = series
              .map(serie => ({
                ...serie,
                date: tratarData(serie.data),
              }))
              .sort((a, b) => a.date.getTime() - b.date.getTime());
            return new IDadosGraficoSeriesMultiplas(
              nome,
              seriesOrdenadas.reduce((acc, serie) => {
                acc[serie.nome] = serie.valor;
                return acc;
              }, {} as Record<string, number>),
            );
          });
        }

        if (objeto.tipo === 'PERCENT-AREA' && objeto.multiplas_series) {
          novoObjeto.multiplas_series = objeto.multiplas_series.map(item => {
            const { nome, series } = item;
            const seriesOrdenadas = series
              .map(serie => ({
                ...serie,
                date: tratarData(serie.data),
              }))
              .sort((a, b) => a.date.getTime() - b.date.getTime());
            return new IDadosGraficoSeriesMultiplas(
              nome,
              seriesOrdenadas.reduce((acc, serie) => {
                acc[serie.nome] = serie.valor;
                return acc;
              }, {} as Record<string, number>),
            );
          });
        }

        if (objeto.tipo === 'AREA' && objeto.series) {
          novoObjeto.series = objeto.series
            .map(item => ({
              name: item.nome,
              value: Number(item.valor),
              date: tratarData(item.data), // Certifique-se de que `date` seja um `Date`
            }))
            .sort((a, b) => a.date.getTime() - b.date.getTime());
        }

        // Conversão para PIZZA
        if (objeto.tipo === 'PIZZA' && objeto.series) {
          novoObjeto.series = objeto.series
            .map(item => ({
              name: item.nome,
              value: Number(item.valor),
              date: tratarData(item.data), // Certifique-se de que `date` seja um `Date`
            }))
            .sort((a, b) => a.date.getTime() - b.date.getTime());
        }

        // Conversão para ROSCA
        if (objeto.tipo === 'ROSCA' && objeto.series) {
          novoObjeto.series = objeto.series
            .map(item => ({
              name: item.nome,
              value: Number(item.valor),
              date: tratarData(item.data), // Certifique-se de que `date` seja um `Date`
            }))
            .sort((a, b) => a.date.getTime() - b.date.getTime());
        }

        // Conversão para CARD
        if (objeto.tipo === 'CARD' && objeto.cartao) {
          novoObjeto.cartao = {
            valor: objeto.cartao.valor,
            percentual: objeto.cartao.percentual,
            descricao: objeto.cartao.descricao,
            // date: objeto.cartao.date ? new Date(objeto.cartao.date) : undefined, // Certifique-se de que `date` seja um `Date`
          };
        }

        return novoObjeto;
      }),
    };

    return novaSecao;
  });
}
